export type ReportCellStatus = "unavailable" | "not_applicable";

export type ReportCell = number | ReportCellStatus;

export type ReportColumnFormat = "count" | "rate" | "usd";

export interface ReportColumn {
  key: string;
  label: string;
  format: ReportColumnFormat;
}

export interface ReportRow {
  label: string;
  cells: Record<string, ReportCell>;
  // A caveat shown beside a cell, keyed like cells.
  cellNotes?: Record<string, string>;
  isTotal?: boolean;
}

export interface ReportTableData {
  rowLabel: string;
  columns: ReportColumn[];
  rows: ReportRow[];
  notes: string[];
}

export const REPORT_CARD_BRANDS = ["VISA", "MASTERCARD", "AMEX", "DISCOVER", "OTHER"] as const;

export type ReportCardBrand = (typeof REPORT_CARD_BRANDS)[number];

export interface ReportsOverviewResponse {
  range: { startDate: string; endDate: string };
  lastWrittenDate: string;
  companyName: string | null;
  brandName: string | null;
  processors: ReportTableData;
  // Standalone PayPal accounts' own table; absent when the company has none enabled or a brand is selected.
  paypal?: ReportTableData;
  paypalCompanyLevelOnly: boolean;
  processorsByCardBrand: Record<ReportCardBrand, ReportTableData>;
  chargebacksByProcessorMonth: ReportTableData;
  chargebacksByReason: ReportTableData;
  chargebacksByCardBrand: ReportTableData;
  alertsByMonth: ReportTableData;
}
